import { render } from "./TeamBotManager.vue?vue&type=template&id=58be41ba&scoped=true"
import script from "./TeamBotManager.vue?vue&type=script&lang=js"
export * from "./TeamBotManager.vue?vue&type=script&lang=js"

import "./TeamBotManager.vue?vue&type=style&index=0&id=58be41ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58be41ba"]])

export default __exports__